<span style="text-align: center; width: 100%;display: block;">
    <span class="mdc-chip tile-chip" *ngIf="params?.value" [ngClass]="styleClass">
        {{params?.value}}
    </span>
</span>